import { useEffect, useState } from "react";
import { useAuthStore } from "../../stores/auth";

interface Props {
  children: React.ReactNode;
}

export function AuthInitializer({ children }: Props) {
  const initialize = useAuthStore((s) => s.initialize);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let cleanup: (() => void) | undefined;
    initialize()
      .then((unsub) => {
        cleanup = unsub;
        setReady(true);
      })
      .catch((err) => {
        console.error("Auth initialization failed", err);
        setReady(true); // still render; user will just see login
      });
    return () => {
      cleanup?.();
    };
  }, [initialize]);

  if (!ready) return null;
  return <>{children}</>;
}
